import React from 'react'
import PropTypes from 'prop-types'
import ContextArticles from '../../../../../../components/ContextArticles'
import Icon from '../../../../../../components/Icon'
import styled, { css } from 'styled-components'
import Link from '../../../../../../components/Link'
import { generatePathByRouteName } from '../../../../../../modules/named-router'
import { setStoredItem, getStoredItem } from '../../../../../../modules/stored-item'

const StyledIcon = styled(Icon)`
  ${(props) =>
    props.active
      ? css`
          color: ${(props) => props.theme.color.stol};
        `
      : css`
          color: ${(props) => props.theme.color.textSecondary};
        `}
`

const StyledLink = styled(Link)`
  color: ${(props) => props.theme.color.textPrimary};
`

const IconNewsFeed = ({ ...props }) => {
  let newPageLoad = true
  let updateIcon = false
  setTimeout(function () {
    updateIcon = true
  }, 30000)

  return (
    <ContextArticles.Consumer>
      {({ lastArticle }) => {
        //if (newPageLoad) setStoredItem('saveLastNewsFeedArticle', true)

        if (lastArticle && newPageLoad) {
          setStoredItem('lastNewsFeedArticleId', lastArticle.id, true)
          //clearStoredItem('saveLastNewsFeedArticle')
          newPageLoad = false
        }
        const clientLastNewsFeedArticleId =
          !isNaN(parseFloat(getStoredItem('lastNewsFeedArticleId', true))) &&
          parseFloat(getStoredItem('lastNewsFeedArticleId', true)) !== undefined
            ? parseFloat(getStoredItem('lastNewsFeedArticleId', true))
            : 0
        //console.log('showRed','updateIcon', updateIcon, 'newPageLoad', newPageLoad, (newPageLoad || updateIcon) && (lastArticle === null || (lastArticle && clientLastNewsFeedArticleId !== lastArticle.id)), (newPageLoad || updateIcon), (lastArticle === null || (lastArticle && clientLastNewsFeedArticleId !== lastArticle.id)), 'lastArticle', lastArticle && lastArticle.id, 'clientLastNewsFeedArticle', clientLastNewsFeedArticleId)
        const showRed = (newPageLoad || updateIcon) && lastArticle && clientLastNewsFeedArticleId !== lastArticle.id

        return (
          <StyledLink to={generatePathByRouteName('newsticker')} {...props}>
            <StyledIcon icon="clock" active={showRed} />
          </StyledLink>
        )
      }}
    </ContextArticles.Consumer>
  )
}

IconNewsFeed.propTypes = {
  as: PropTypes.func,
}

export default IconNewsFeed
